import React from 'react';

const MacroGuideModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const macroList = [
    { macro: "#{학생명}", desc: "학생 이름" },
    { macro: "#{반이름}", desc: "반 이름" },
    { macro: "#{제출일}", desc: "과제 제출일" },
    { macro: "#{수업결과링크}", desc: "수업 결과 링크" },
    { macro: "#{시험지유형}", desc: "시험지 유형" },
    { macro: "#{과제명}", desc: "과제 제목" },
    { macro: "#{점수}", desc: "과제 점수" },
    { macro: "#{과제리포트주소}", desc: "상세 리포트 링크" },
    { macro: "#{알림장내용}", desc: "특이사항 내용" },
    { macro: "#{수업제목}", desc: "수업 제목 목록" },
    { macro: "#{시험제목}", desc: "시험 제목 목록" },
    { macro: "#{시험점수}", desc: "시험 제목 및 점수" },
    { macro: "#{과제제목}", desc: "과제 제목 목록" },
    { macro: "#{과제점수}", desc: "과제 제목 및 점수" }
  ];

  return (
    <div 
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: "white",
          borderRadius: "12px",
          width: "min(90%, calc(100vw - 32px))",
          maxWidth: "700px",
          maxHeight: "80vh",
          overflowY: "auto", WebkitOverflowScrolling: "touch",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.3)"
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 24px",
          borderBottom: "1px solid #E6EDEC",
          background: "#F4F8F7",
          borderRadius: "12px 12px 0 0"
        }}>
          <h3 style={{ margin: "0", fontSize: "18px", color: "#3A434E", fontWeight: "600" }}>
            사용 가능한 매크로
          </h3>
          <button 
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              color: "#7A8490",
              padding: "4px",
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
              transition: "all 0.2s"
            }}
            onMouseOver={(e) => {
              e.target.style.background = "rgba(0, 0, 0, 0.1)";
              e.target.style.color = "#3A434E";
            }}
            onMouseOut={(e) => {
              e.target.style.background = "none";
              e.target.style.color = "#7A8490";
            }}
          >
            ×
          </button>
        </div>
        
        <div style={{ padding: "24px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {macroList.map((item, index) => (
              <div key={index} style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 16px",
                background: "#F4F8F7",
                borderRadius: "6px",
                border: "1px solid #E6EDEC"
              }}>
                <code style={{
                  background: "#0E141B",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontFamily: "'Courier New', monospace",
                  fontWeight: "bold"
                }}>
                  {item.macro}
                </code>
                <span style={{ color: "#3A434E", fontSize: "14px", fontWeight: "600" }}>
                  {item.desc}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MacroGuideModal;